import React from 'react';
import Checkbox from '../../../../elements/Checkbox/Checkbox';
import Stylesheet from './Record.module.css';
import Classnames from 'classnames';
import { AppContext } from '../../../../contexts/app';
import { useHistory, useLocation } from 'react-router-dom';
import Cell from '../../elements/Cell/Cell';
import { TableContext } from '../../context/table';
import { QueryContext } from '../../context/query';
/**
 * Default Record Component for Table Component
 */
const Record = (props) => {
    let history = useHistory();
    let location = useLocation();
    let app = null;
    let table = null;
    let query = null;
    const metadata = props.metadata;
    const init = (appContext, tableContext, queryContext) => {
        app = appContext;
        table = tableContext;
        query = queryContext;
    }
    const isSelected = _ => {
        if (location.search.search(/select=all/g) > 0) return true;
        if (query?.selected.records.find(({id}) => id === metadata.id)) return true;
        return false;
    }
    const onSelect = _ => {
        // search always has 1 element
        const search = query.search.search[0];
        if (query?.selected.records.length === 0) {
            history.push(`?select=${metadata.id}${search ? '&search='+search : ""}`)
            return;
        }
        let list = [];
        for (const record of query?.selected.records)
            list.push(record.id);
        // check if current record is selected
        const index = list
        .findIndex((id) => id === metadata.id);
        // deselect record
        if (isSelected()) list.splice(index, 1);
        // select record
        else list.push(metadata.id);
        // update url
        history.push(`?select=${list.join(',')}${search ? '&search='+search : ""}`)
    }
    // render records cells
    const cells = config => {
        let collection = [];
        // add auto comolumns
        if (!config?.disableID) 
            collection.push(
                <Cell metadata={metadata} 
                column={{
                    title: "id", 
                    name: "id", 
                    type: "primaryKey"
                }} 
                table={table?.metadata}
                config={table.config}
                appContext={app}
                key={collection.length} />)
        // identify column schemas and render cells
        for (const column of table?.schema) {
            collection.push(
                <Cell metadata={metadata} 
                column={column} 
                table={table?.metadata}
                config={table.config}
                appContext={app}
                key={collection.length} />
            )
        }
        collection.push(
            <Cell metadata={metadata} 
            column={{
                title: "branch", 
                name: "branch", 
                type: "string", 
                default: "currentuserid"
            }} 
            table={table?.metadata}
            config={table.config}
            appContext={app}
            key={collection.length} />)
        if (!config?.disableAuthor) 
            collection.push(
                <Cell metadata={metadata} 
                column={{
                    title: "author", 
                    name: "author", 
                    type: "user", 
                    default: "currentuserid"
                }} 
                table={table?.metadata}
                config={table.config}
                appContext={app}
                key={collection.length} />)
        if (!config?.disableTimestamp) 
            collection.push(
                <Cell metadata={metadata} 
                column={{
                    title: "date created", 
                    name: "timestamp", 
                    type: "timestamp"
                }} 
                table={table?.metadata}
                config={table.config}
                appContext={app}
                key={collection.length} />)
        return collection;
    }

    const content = config => {
        return (
            <div className={Classnames(Stylesheet.Container, {
            [Stylesheet["Selected"]]: isSelected() })}>
                {init(app, table, query)}
                <div className={Stylesheet.Select}>
                    <Checkbox onChange={onSelect} 
                    value={isSelected()} />
                </div>
                {cells(config).map((value) => (value))}
            </div>
        )
    }

    return (
        <AppContext.Consumer>
            {app => (
                <TableContext.Consumer>
                {table => (
                    <QueryContext.Consumer>
                        {query => (
                            <React.Fragment>
                                {init(app, table, query)}
                                {content(table.config)}
                            </React.Fragment>
                        )}
                    </QueryContext.Consumer>
                )}
                </TableContext.Consumer>
            )}
        </AppContext.Consumer>
    )

}

export default Record;